function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.6991 8.85659C24.1028 8.38581 24.1047 7.62045 23.678 7.17809C22.214 5.66043 20.541 4.43691 18.7269 3.56053C16.5942 2.53029 14.3084 2 12 2C9.69163 2 7.40584 2.53029 5.27316 3.56053C3.45903 4.4369 1.78596 5.66045 0.321981 7.17809C-0.104737 7.62044 -0.102774 8.38582 0.300882 8.8566L1.02316 9.69899C1.42731 10.1704 2.08087 10.1674 2.51338 9.73145C5.05629 7.16846 8.37261 5.61782 12 5.61782C15.6274 5.61782 18.9437 7.16846 21.4866 9.73145C21.9191 10.1674 22.5727 10.1704 22.9768 9.69899L23.6991 8.85659Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.0497 13.1129C20.4539 12.6415 20.4559 11.8736 20.019 11.4437C17.8545 9.31374 15.056 8.02971 12 8.02971C8.94396 8.02971 6.14551 9.31374 3.981 11.4437C3.5441 11.8736 3.54613 12.6415 3.95028 13.1129L5.41388 14.8198C5.81803 15.2912 6.47041 15.2849 6.92225 14.8764C8.32486 13.6084 10.0867 12.8535 12 12.8535C13.9133 12.8535 15.6751 13.6084 17.0777 14.8764C17.5296 15.2849 18.182 15.2912 18.5861 14.8198L20.0497 13.1129Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.2669 21.646C11.6716 22.118 12.3284 22.118 12.7331 21.646L15.6589 18.2337C16.0631 17.7623 16.0665 16.9889 15.6005 16.6026C14.5846 15.7606 13.342 15.2654 12 15.2654C10.658 15.2654 9.41535 15.7606 8.39951 16.6026C7.93349 16.9889 7.93692 17.7623 8.34107 18.2337L11.2669 21.646Z",
  fill: "currentColor"
});

var SvgWifi = function SvgWifi(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWifi, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wifi.7b58b9cb.svg";
export { ForwardRef as ReactComponent };